// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".l-container[data-v-2ccb49e7]{padding-top:50px;padding-bottom:50px}@media screen and (max-width:640px){.l-container[data-v-2ccb49e7]{padding:10px 0 20px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
